<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: the handlers only stop propagation around the SearchInput, which is the real control -->
<script lang="ts" setup>
  import { useLocale } from '@tundr/i18n';
  import { onMounted, ref, watch } from 'vue';
  import SearchInput from '../../SearchInput/SearchInput.vue';
  import { searchInlineClass, searchRowClass } from './SelectTrigger.css';

  const props = defineProps<{
    query?: string;
    inline?: boolean;
    testId?: string;
    inputAttrs?: Record<string, string | boolean | undefined>;
  }>();

  const emit = defineEmits<{
    'update:query': [query: string];
    navigate: [event: KeyboardEvent];
  }>();

  const { t } = useLocale('ds-components');

  const rootEl = ref<HTMLElement | null>(null);

  const applyInputAttrs = () => {
    const input = rootEl.value?.querySelector('input');
    if (!input || !props.inputAttrs) return;
    for (const [name, value] of Object.entries(props.inputAttrs)) {
      if (value === undefined) input.removeAttribute(name);
      else input.setAttribute(name, String(value));
    }
  };

  onMounted(applyInputAttrs);

  watch(() => props.inputAttrs, applyInputAttrs, { flush: 'post' });

  const NAVIGATION_KEYS = new Set([
    'ArrowDown',
    'ArrowUp',
    'Home',
    'End',
    'Enter',
    'Escape',
  ]);

  const onKeydown = (event: KeyboardEvent) => {
    if (NAVIGATION_KEYS.has(event.key)) emit('navigate', event);
  };
</script>

<template>
  <div
    ref="rootEl"
    :class="[searchRowClass, { [searchInlineClass]: inline }]"
    :data-test-id="testId"
    @click.stop
    @mousedown.stop
    @keydown.stop="onKeydown"
  >
    <SearchInput
      name="select-search"
      test-id="select-search"
      :model-value="query"
      :placeholder="t('select.search_placeholder')"
      @update:model-value="(value) => emit('update:query', value)"
    />
  </div>
</template>
